import React from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import InsurancePlanOverview from '@/b2c/PlanDetail/Overview/InsurancePlanOverview';
import FundPlatformOverview from '@/b2c/PlanDetail/Overview/FundPlatformOverview';
import InvestmentLinkOverview from '@/b2c/PlanDetail/Overview/InvestmentLinkOverview';
import styles from '@/b2c/PlanDetail/Overview/index.module.css';

const Overview = ({plan}) => {
  const {t: tr, i18n: i18nCtx} = useTranslation('planDetail');
  const CategoryMappedOverview = R.compose(
    R.flip(R.prop)({
      MPF: FundPlatformOverview,
      FD: FundPlatformOverview,
      PB: FundPlatformOverview, // any non 'Policy' product category shall go into FundPlatform
      IN: InsurancePlanOverview,
      IL: InvestmentLinkOverview,
      TU: InvestmentLinkOverview,
    }),
    R.prop('productCategory')
  )(plan);

  return (
    <>
      <h4>{tr('overview')}</h4>
      {i18nCtx.language === 'ja' && (
        <span className={`${styles.plan_detail_remark}`}>
          {tr('auto_translate_remark_1')}
          <br />
          {tr('auto_translate_remark_2')}
        </span>
      )}
      <CategoryMappedOverview plan={plan} />
    </>
  );
};

export default Overview;
